export default __webpack_public_path__ + "static/media/shoppingBag.2fdd2842.svg";